export enum GenericStepType {
  VIDEO_STEP = 'video-step',
}
